// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8934) return "static/chunks/8934.d138fe277bbbe22b.js";
	if (chunkId === 8131) return "static/chunks/8131.6e835cb8fbf157ff.js";
	if (chunkId === 6542) return "static/chunks/6542.f6a151900b223583.js";
	if (chunkId === 2916) return "static/chunks/2916.0598d9625a0e1345.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"223":"491b89076dd8b89d","2117":"c7ffc24eb563a501","3995":"0a1df4727a1b5206","5705":"61dd814f927aa6e9","7253":"0fdc042f2d7b89ff","7505":"acb5e8cdcb07fa95","7847":"5e384a54ae12dc6d","8048":"83889112e5772720"}[chunkId] + ".js";
};